import { render } from "./UserPrivacyOnlyRegistrationByCode.vue?vue&type=template&id=12d82c26&scoped=true&ts=true"
import script from "./UserPrivacyOnlyRegistrationByCode.vue?vue&type=script&lang=ts"
export * from "./UserPrivacyOnlyRegistrationByCode.vue?vue&type=script&lang=ts"

import "./UserPrivacyOnlyRegistrationByCode.vue?vue&type=style&index=0&id=12d82c26&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d82c26"]])

export default __exports__